import React from 'react';
const stats = [['1500+', 'Insegnanti di Pilates in tutta Italia'], ['6 + 5', 'Volumi e bonus esclusivi'], ['4.9/5', 'Valutazione media delle professioniste'], ['Ogni giorno', 'Per elevare lo standard dello Studio']];
const notes = [['“Ho pianificato l’intero anno di Pilates in una sola sera. Ora ogni lezione ha un obiettivo chiaro e le mie allieve non vedono l’ora di tornare sul Reformer.”', 'Martina R.', 'Istruttrice di Pilates · Milano'], ['“Le mie allieve migliorano più velocemente perché seguono finalmente una progressione logica. Ha cambiato il mio modo di insegnare Pilates.”', 'Elena B.', 'Studio Owner Pilates · Roma']];
export function ProofSection() {
  return <section className="bg-[#241622] px-5 pb-16" data-id="element-226" data-mp="3nrenk1lb7p9d">
      <div className="mx-auto max-w-6xl" data-id="element-227" data-mp="3nq3blehpnb76">
        <div className="grid grid-cols-2 overflow-hidden rounded-2xl border border-emerald-300/25 bg-[#38233c] sm:grid-cols-4" data-id="element-228" data-mp="3sqhj8vfegj4o">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-emerald-300/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-229" data-mp="1kpv21l6ngki">
              <p className="font-display text-4xl font-bold uppercase text-emerald-300 sm:text-5xl" data-id="element-230" data-mp="15l5egwybdj2t">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-slate-300" data-id="element-231" data-mp="vqde5ldcki4c">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-232" data-mp="1odq2o132j00a">
          {notes.map(([quote, name, role]) => <figure key={name} className="flex flex-col rounded-2xl border border-emerald-950/10 bg-white p-7" data-id="element-233" data-mp="1jewpyavlvd16">
              <div className="mb-4 text-amber-500" aria-label="5 stelle su 5" data-id="element-234" data-mp="1enoc92n8t5i7">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#09281d]" data-id="element-235" data-mp="1aljnah7qox1w">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-emerald-950/10 pt-4 text-sm font-bold text-[#09281d]" data-id="element-236" data-mp="22dsg9b4cf79q">
                {name}
                <span className="ml-2 text-xs font-medium text-slate-600" data-id="element-237" data-mp="fysto20uba9">
                  {role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}